"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeInternetStatusManager = void 0;
class FakeInternetStatusManager {
    unknown() { }
    possiblyOffline() { }
    possiblyOnline() { }
    offline() { }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    waitForOnline(abortContext) {
        return Promise.resolve();
    }
    isConnected() {
        return true;
    }
    isOffline() {
        throw new Error("Method not implemented.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange(cb) {
        throw new Error("Method not implemented.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    startMonitoring(internetStatusListener) { }
    stopMonitoring() { }
}
exports.FakeInternetStatusManager = FakeInternetStatusManager;
